import {POST, GET} from "@/services/gateway";

const list = () => {
  return GET('google/classroom/backupsettings');
}

const updateAutoAdd = ({seatType, autoAdd}) => {
  return POST('google/classroom/backupsettings', {
    seatType, autoAdd
  })
}


export {
  list,
  updateAutoAdd
}
